import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { ITableV2Column } from "components/table-v2/table-v2";
import { DATE_FORMAT } from "constants/date";
import { TAccountJourney } from "types/account-journeys.type";
import { TSelectOption } from "types/select-input.type";
import { formatDate } from "utils/date.utils";

export const journeyTableColumnDef = (
  filtersOptions: TSelectOption<number>[],
  handleCreateOrEditJourney: (row: TAccountJourney) => () => void,
  handleDeleteJourney: (row: TAccountJourney) => () => void
): ITableV2Column<TAccountJourney>[] => {
  return [
    {
      accessor: "name",
      Header: <DefaultHeaderCell>Name</DefaultHeaderCell>,
      Cell: ({ row }) => <DefaultRowCell>{row.name}</DefaultRowCell>,
    },
    {
      accessor: "leadFilterId",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Filter</DefaultHeaderCell>,
      Cell: ({ row }) => {
        const name = filtersOptions.find(
          filter => filter.value === row.leadFilterId
        )?.label;

        return <DefaultRowCell>{name ? name : ""}</DefaultRowCell>;
      },
    },
    {
      accessor: "createdAt",
      excludeFromGlobalFilter: true,
      width: "100px",
      Header: <DefaultHeaderCell>Created</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          {formatDate(row.createdAt, DATE_FORMAT)}
        </DefaultRowCell>
      ),
    },
    {
      accessor: "updatedAt",
      excludeFromGlobalFilter: true,
      width: "100px",
      Header: <DefaultHeaderCell>Last edited</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          {formatDate(row.updatedAt, DATE_FORMAT)}
        </DefaultRowCell>
      ),
    },
    {
      accessor: "id",
      width: "30px",
      disableSortBy: true,
      excludeFromGlobalFilter: true,
      Header: null,
      Cell: ({ row }) => (
        <DefaultRowCell
          justifyContent={"flex-end"}
          onClick={event => event.stopPropagation()}
        >
          <Menu isLazy={true} placement={"bottom-end"}>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={
                <FontAwesomeIcon icon={faEllipsisVertical} fontSize="16px" />
              }
              size="xs"
              variant="ghost"
            />
            <MenuList>
              <MenuItem onClick={handleCreateOrEditJourney(row)}>Edit</MenuItem>
              <MenuItem onClick={handleDeleteJourney(row)}>Remove</MenuItem>
            </MenuList>
          </Menu>
        </DefaultRowCell>
      ),
    },
  ];
};
